module.exports = __webpack_public_path__ + "static/media/notPhoto.81cce80e.jpg";